import React from 'react';
import '../interfaceSettings.css';

const Privacy = () => {
    return (
        <section id="privacy" className="container mt-5 mb-5">
            <div className="privacy-content" style={{ maxWidth: '800px', margin: '0 auto' }}>
                <h1 className="mb-4">Privacy Policy</h1>
                
                <p className="lead mb-4">
                    We will not obtain personally identifying information about you when you visit the GGC Trails app or website unless you choose to register an account. Registration is limited to users 18 years of age or older. Except as required by law, no information you provide will be shared with outside parties.
                </p>

                <hr className="my-4" />

                <h2 id='privacyInfoHeader' className="mt-5 mb-3">Information You Provide</h2>
                <p className="mb-3">
                    When you create an account, we collect your username and email address for login and password retrieval. You may also choose to provide optional details such as:
                </p>
                <ul className="mb-4">
                <li>Birthday (to determine age)</li>
                <li>Gender (with “prefer not to specify” option)</li>
                <li>Ethnicity (with “prefer not to specify” option)</li>
                    <li>Part of GGC Community (yes or no)</li>
                </ul>
                <p className="mb-2">
                    Frequency of app usage, trail usage, and video interactions are collected with your consent.
                </p>
                <p className="mb-4">
                    No location data or other sensitive identifying information is collected.
                </p>

                <h2 className="mt-5 mb-3">How Your Information Is Used</h2>
                <p className="mb-4">
                    Your information is used only to operate the app, provide fitness content about the GGC walking trails, and support GGC research on app usage.
                </p>

                <h2 className="mt-5 mb-3">Your Rights</h2>
                <p className="mb-4">
                    Participation is voluntary. You may access, update, or delete your personal information at any time through your account settings, and you may stop using the app at any time without penalty.
                </p>

                <h2 className="mt-5 mb-3">Consent</h2>
                <p className="mb-4">
                    By creating an account, you consent to the collection, storage, and use of your data as described in this Privacy Policy and the GGC Trails User Agreement.
                </p>
            </div>
        </section>
    );
};

export default Privacy;